export enum ApplicationStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const ApplicationStatusOptions = [
  {
    label: "Active",
    value: ApplicationStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: ApplicationStatus.INACTIVE,
  },
];
